"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    hasBorder: _propTypes.default.bool,
    hasBoxShadow: _propTypes.default.bool,
    titleFirst: _propTypes.default.bool,
    imgWidth: _propTypes.default.string,
    imgHeight: _propTypes.default.string,
    iconPosition: _propTypes.default.string,
    translation: _propTypes.default.object,
    dataList: _propTypes.default.arrayOf(_propTypes.default.shape({
      iconName: _propTypes.default.string,
      mainDisplayName: _propTypes.default.string,
      mainDisplayNameQty: _propTypes.default.string,
      value: _propTypes.default.string
    })).isRequired,
    isMobile: _propTypes.default.bool,
    hasHeader: _propTypes.default.bool,
    hasNoCheckedBaggage: _propTypes.default.bool,
    hasNoCheckedBaggageOnly: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    hasBoxShadow: false,
    titleFirst: true,
    iconPosition: 'left',
    imgHeight: '32px',
    imgWidth: '32px',
    dataList: [],
    isMobile: false,
    hasHeader: true,
    hasNoCheckedBaggage: false,
    hasNoCheckedBaggageOnly: false
  }
};
exports.default = _default;